/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const SquareArrowRightEnter = createLucideIcon("square-arrow-right-enter", [
  ["path", { d: "m10 16 4-4-4-4", key: "w9835o" }],
  ["path", { d: "M3 12h11", key: "pmja8f" }],
  [
    "path",
    {
      d: "M3 8V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3",
      key: "1bqs5q"
    }
  ]
]);

export { SquareArrowRightEnter as default };
//# sourceMappingURL=square-arrow-right-enter.js.map
